import { render, staticRenderFns } from "./RecargosFormType.vue?vue&type=template&id=5f0a8916"
import script from "./RecargosFormType.vue?vue&type=script&lang=js"
export * from "./RecargosFormType.vue?vue&type=script&lang=js"
import style0 from "./RecargosFormType.vue?vue&type=style&index=0&id=5f0a8916&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports